<template>
  <div>
    <!-- 顶部栏 -->
    <div ref="header">
      <home-header ref="homeHeader" @openMenus="openMenus"></home-header>
    </div>
    <div class="container">
      <!-- 左侧侧边栏 -->
      <div ref="sider">
        <home-sider></home-sider>
      </div>
      <!-- 右侧主要内容 -->
      <div class="content home-content" ref="content">
        <router-view></router-view>
        <remote-assistance style="z-index:800"></remote-assistance>
      </div>
      <loading :show="false"></loading>
    </div>
    <!-- <fade-down-modal class="global-msg" :show="showState">
            <div style="background:#fff;" :style="{ width: modalWidth + 'px' }">
                <div class="headerTag">
                    <header-tag :title="title"></header-tag>
                </div>
                <div class="body">
                    <p>
                        由于版本升级，部分网吧服务端和客户端会自动升级到新版本(7.0版)，WEB管理端无法远程控制版本号低于7.0的服务端或客户端。
                    </p>
                    <p>
                        如果您要远程控制版本号低于7.0的服务端或客户端，请到首页下载使用6.7版远程管理端
                        Windows 版。
                    </p>
                    <p>
                        有任何疑问欢迎<a
                            href="http://q.url.cn/abnhLo?_type=wpa&amp;qidian=true"
                            target="_blank"
                            >联系在线技术支持</a
                        >
                    </p>
                </div>
                <div class="bottom">
                    <div class="right">
                        <a
                            href="#"
                            class="blue-btn"
                            @click.prevent="confirm"
                            v-text="comfirmText"
                        >
                        </a>
                    </div>
                </div>
            </div>
        </fade-down-modal> -->
    <!-- <Modal
      v-model="modal1"
      title="  "
      @on-ok="closeNoticeFn"
      @on-cancel="closeNoticeFn"
      width="700"
    >
      <h3 class="fw f14" style="line-height:24px;">
        年关将至，如何多搞点钱回家过年？
      </h3>
      <h3 class="fw f14" style="line-height:24px;">
        过年休息的时候如何持续赚钱？又不被网吧老板嫌弃？
      </h3>
      <p style="line-height:24px;">
        鉴于吃鸡免费，春节将至，吃鸡活跃度回升到2019年9月水平，加速器扫码量将会上升。
      </p>
      <p style="line-height:24px;">
        鉴于腾讯加速器网吧行业合约到期后，UU+雷神将满足93%的顾客使用需求。
      </p>
      <p style="line-height:24px;">
        鉴于全国疫情反反复复，维护商朋友们的经济收益诉求及维护大师持续发展的商业化诉求。
      </p>
      <p style="line-height:24px;">
        鉴于维护大师与赚吧分别获得网易7省，雷神全国唯一代理，有权限及资源扶持大家开展业务。基于以上，我们决定——撒钱！计划如下：
      </p>
      <p style="line-height:24px;">
        1月26日起凡是安装维护大师客户端的网吧，安装次日全自动开通UU、雷神扫码版加速器，并有如下贴心设计：
      </p>
      <p style="line-height:24px;">
        -支持UU/雷神自动绑定ip，雷神同步增加pin（动态ip）支持模式。
      </p>
      <p style="line-height:24px;">
        -支持UU/雷神包月到期自动转扫码，且雷神分成比例调整到60%。
      </p>
      <p style="line-height:24px;">
        -支持自动避免重复创建桌面快捷方式。
      </p>
      <p style="line-height:24px;">
        -支持内网p2p全自动升级加速器客户端。
      </p>
      <p>
        总的来说，一次部署持久受益，如不需要，可自行在赚吧关闭，关闭后不再自动开启，如有疑问可联系商务C咨询。
      </p>
      <p style="line-height:24px;">
        最后，让我们共克时艰，携手共赢，维护大师&赚吧预祝小伙伴们，新春快乐，万事如意，虎年大吉！
      </p>
    </Modal> -->
  </div>
</template>

<script>
import loading from '_c/modals/loading'
import HomeHeader from './homeHeader'
import HomeSider from './homeSider'
import RemoteAssistance from './modals/remoteAssistance'
import { freeTrial } from '@/requests/user'
import { mapActions } from 'vuex'
// import FadeDownModal from "_c/modals/fadeDown";
// import HeaderTag from "_c/tagTitle/headerTag";
import { mapState } from 'vuex'
export default {
  name: 'home',
  components: {
    HomeHeader,
    HomeSider,
    RemoteAssistance,
    loading,
    // FadeDownModal,
    // HeaderTag,
  },
  watch: {
    '$store.state.user.notice'() {
      if (this.$store.state.user.notice) {
        if (!this.localStorage.getItem('showNotcie') == 1) {
          this.modal1 = true
        }
      }
    },
  },
  data() {
    return {
      // showState: false,
      modalWidth: 600,
      title: 'WEB管理端兼容性提示',
      comfirmText: '确定',
      modal1: false,
    }
  },
  computed: {
    ...mapState({
      statement: (state) => state.user.statement,
    }),
  },
  mounted() {
    // if (this.statement == 1) {
    //     this.showState = true;
    // }
    this.localStorage = window.localStorage
    if (this.localStorage.getItem('showNotcie') == 1) {
      this.modal1 = false
    }
    document.querySelector('.home-sider').style.width = '180px'
    document.querySelector('.home-content').style.left = '180px'
    this.$refs.homeHeader.state = 0
    this.getUser()
  },
  methods: {
    closeNoticeFn() {
      this.modal1 = false
      this.localStorage.setItem('showNotcie', 1)
    },
    // confirm() {
    //     this.showState = false;
    // },
    async getUser() {
      this['user/actionSetUserInfo']()
      this['user/actionSetOEMInfo']()
      if (this.$route.query.val == 2) {
        let res = await freeTrial({
          passportName: this.$store.state.user.userInfo.passportName,
        })
        if (res.code == 200) {
          window.$Message.hide()
          window.$Message.show({
            title: '试用SVIP',
            type: 'success',
            msg: res.msg,
            confirmTxt: '关闭',
            confirmFn: () => {
              this['user/actionSetUserInfo']()
              this.$router.push({
                path: this.$PAGE_API.home.path,
              })
              window.$Message.hide()
            },
          })
        } else {
          setTimeout(() => {
            window.$Message.show({
              title: '试用SVIP',
              type: 'error',
              msg: res.msg,
              confirmFn: () => {
                this.$router.push({
                  path: this.$PAGE_API.home.path,
                })
                window.$Message.hide()
              },
            })
          }, 100)
        }
      }
    },
    ...mapActions(['user/actionSetUserInfo', 'user/actionSetOEMInfo']),
    openMenus(val) {
      if (val == 1) {
        document.querySelector('.home-sider').style.width = '180px'
        document.querySelector('.home-content').style.left = '180px'
        this.$refs.homeHeader.state = 0
      } else {
        document.querySelector('.home-sider').style.width = '60px'
        document.querySelector('.home-content').style.left = '60px'
        this.$refs.homeHeader.state = 1
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  position: absolute;
  left: 0;
  right: 0;
  top: 60px;
  bottom: 0;
}
.content {
  position: absolute;
  left: 60px;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 80;
  transition: all 0.2s;
  overflow: auto;
}
.global-msg {
  z-index: 900;
}
.headerTag {
  height: 50px;
  line-height: 50px;
  text-align: left;
  padding-left: 30px;
  border-bottom: 1px solid #e5e5e5;
}
.bottom {
  overflow: hidden;
  text-align: right;
  padding-right: 30px;
  padding-left: 30px;
  height: 70px;
  border-top: 1px solid #e5e5e5;
  a {
    min-width: 90px;
    text-align: center;
  }
  .right {
    padding: 20px;
  }
}
.body {
  padding: 20px;
  text-align: left;
  > p {
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
    // font-size: 16px;
    font-size: 12px;
    color: #515151;
  }
}
</style>
